<div class="container">
  <div class="address-title-and-closed">
    <h3 class="title">{{ titleModal }}</h3>
    <button class="btn" (click)="openDropdown()" *ngIf="unit">
      <img src="../../../../assets/svgs/i_dot_options.svg" alt="Fechar" />
    </button>
    <ul class="dp-list" *ngIf="openDropDown">
      <li class="dp-item">
        <a class="dp-action">
          <span (click)="openDialog()">Editar</span>
        </a>
      </li>
    </ul>
  </div>
  <div *ngIf="!unit">
    <button class="btn-capture-unit" (click)="openDialog()">
      Captar Unidade
    </button>
  </div>
  <div class="unit" *ngIf="unit">
    <p>
      {{ unitString }}
    </p>
  </div>
</div>
